import { render, staticRenderFns } from "./PostalCode.vue?vue&type=template&id=dbcc2f14&scoped=true"
import script from "./PostalCode.vue?vue&type=script&lang=js"
export * from "./PostalCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcc2f14",
  null
  
)

export default component.exports